import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { fetchPublicSiteContent } from './api';
import { setPublishedSiteContent, useSiteContentVersion } from './runtime';

export const PUBLIC_SITE_CONTENT_QUERY_KEY = ['public', 'site-content'] as const;

/**
 * Fetch what the owner published and apply it. Returns the content version,
 * which the caller keys its tree on so the edited copy renders.
 *
 * A failed fetch leaves the last copy this browser saw, or the shipped one -
 * the marketing site never waits on, or breaks over, its own content.
 */
export function useSiteContentSync(): number {
  const { data } = useQuery({
    queryKey: PUBLIC_SITE_CONTENT_QUERY_KEY,
    queryFn: fetchPublicSiteContent,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });

  useEffect(() => {
    if (data) setPublishedSiteContent(data);
  }, [data]);

  return useSiteContentVersion();
}
